import updateFromApi from "./updateFromApi";
import { updateNavigationTree } from "../../template/state/modules/navigation";
import { getFromLocalStorage } from "./navigationLocalStorage";

const getCountryData = store => {
  const {
    regionalStore: {
      countryCode,
      defaultLanguage,
      storeUrls,
      keyStoreDataversion
    },
    layout: { platform }
  } = store.getState();

  return [
    defaultLanguage,
    countryCode,
    storeUrls.default,
    platform,
    keyStoreDataversion
  ];
};

export const reloadNavigation = async store => {
  const [
    language,
    countryCode,
    storeUrl,
    platform,
    ksdvFromRegionalStore: keyStoreDataversion
  ] = getCountryData(store);

  const {
    data,
    time,
    keyStoreDataversion: ksdvFromLocalStorage
  } = getFromLocalStorage({
    countryCode,
    language
  });

  if (
    data &&
    time > Date.now() &&
    ksdvFromLocalStorage === ksdvFromRegionalStore
  ) {
    store.dispatch(updateNavigationTree(data));
  } else {
    updateFromApi({
      countryCode,
      language,
      store,
      storeUrl,
      platform,
      fromLocalStorage: data,
      keyStoreDataversion: ksdvFromRegionalStore
    });
  }
};



// WEBPACK FOOTER //
// ./client/navigation/index.js